import { useState } from "react";
import { MembersFilters } from "@/react/components/Spaces/MembersSpace/Filters/MembersFilters";
import { userIsAdminOrModeratorOfSpace } from "@/react/helpers/spaceHelpers";
import { MembersSearch } from "@circle-react/components/MemberDirectory/Header/MemberSearch";
import type { Space } from "@circle-react/types";
import { Filters } from "@circle-react-shared/MembersList/Filters";

interface FiltersWrapperProps {
  space: Space;
}

export const FiltersWrapper = ({ space }: FiltersWrapperProps) => {
  const shouldShowAdminFilters = userIsAdminOrModeratorOfSpace(space);
  const [
    shouldRenderMobileFiltersTransition,
    setShouldRenderMobileFiltersTransition,
  ] = useState(false);

  return (
    <>
      <MembersSearch
        setShouldRenderMobileFiltersTransition={
          setShouldRenderMobileFiltersTransition
        }
      />
      <MembersFilters />
      <Filters
        // Mobile (legacy) filters
        className="sm:!mx-6 lg:!mx-6"
        shouldBeHiddenOnMd
        shouldShowSpacesFilter={false}
        shouldShowAdminFilters={shouldShowAdminFilters}
        shouldRenderMobileFiltersTransition={
          shouldRenderMobileFiltersTransition
        }
      />
    </>
  );
};
